<template>
    <span v-if="mostrarBtnAprovarReprovar">
        <b-button
            variant="primary"
            @click.stop="confirmarAprovarReprovar('A')"
            v-if="mostrarBtnAprovar"
            class="mr-2"
        >
            <span> <i class="fa fa-check-circle"></i> Aprovar </span>
        </b-button>
        <b-button variant="danger" @click.stop="abrirDetalheReprovacao()">
            <span> <i class="fa fa-times-circle"></i> Reprovar </span>
        </b-button>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheReprovacao"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da Reprovação
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">
                            Categoria da reprovação
                        </label>
                        <b-form-select
                            :options="categoriasReprovacao"
                            v-model="categoriaReprovacaoId"
                            text-field="descricao"
                            value-field="id"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="insereEmailGestorFMO">
                    <b-form-group>
                        <label class="required">
                            Email do gestor do FMO
                        </label>
                        <b-form-select
                            :options="funcionarios"
                            v-model="emailGestorFMO"
                            text-field="nome"
                            value-field="email"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="insereDetalheReprovacao">
                    <b-form-group>
                        <label for="contato">Justificativa</label>
                        <b-form-textarea
                            v-model="detalheReprovacao"
                            :rows="4"
                            @input="$v.detalheReprovacao.$touch()"
                            :state="$v.detalheReprovacao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheReprovacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAprovarReprovar('R')"
                    class="ml-2"
                >
                    <span> <i class="fa fa-times-circle"></i> Reprovar </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'
import { perfil } from '../../DespesasGeraisPerfis'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModalDetalheReprovacao: false,
            detalheReprovacao: '',
            categoriasReprovacao: [],
            categoriaReprovacaoId: null,
            categoriasDetalheId: [],
            categoriaFMOId: null,
            emailGestorFMO: '',
            funcionarios: []
        }
    },

    methods: {
        abrirDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = true
        },

        fecharDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = false
            this.detalheReprovacao = ''
        },

        confirmarAprovarReprovar(acao) {
            let acaoTitulo
            let acaoMensagem
            if (acao === 'A') {
                acaoTitulo = 'Aprovar'
                acaoMensagem = 'aprovação'
            } else {
                acaoTitulo = 'Reprovar'
                acaoMensagem = 'reprovação'
            }
            this.$swal({
                title: `${acaoTitulo} Registro de Pagamento`,
                html: `Confirma a ${acaoMensagem} do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.aprovarReprovar(acao)
                }
            })
        },

        aprovarReprovar(acao) {
            this.$store.dispatch('addRequest')
            let aprovaReprovaPagamentoDto = {
                pagamentoId: this.$route.params.pagamentoId,
                acao: acao,
                detalheReprovacao: this.insereDetalheReprovacao ? this.detalheReprovacao : null,
                perfil: this.perfil,
                categoriaReprovacaoId: this.categoriaReprovacaoId,
                emailGestorFMO: this.insereEmailGestorFMO ? this.emailGestorFMO : null
            }
            this.pagamentosServicos
                .aprovarReprovarPagamento(aprovaReprovaPagamentoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.fecharDetalheReprovacao()
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar registro de pagamento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterCategoriasReprovacao() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterCategoriasReprovacao()
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.categoriasReprovacao = response.data.categoriasReprovacao
                            this.categoriasDetalheId = response.data.categoriasDetalheId
                            this.categoriaFMOId = response.data.categoriaFMOId
                            this.funcionarios = response.data.funcionarios
                        } else {
                            this.error = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAprovarReprovar() {
            return (
                (this.$route.name == 'DespesasGerais_Finalizacao_Pagamentos_Detalhar' &&
                    this.$temAcesso('DESP-GERAIS-FINAL-PAG-02') &&
                    (this.pagamento.status === pagamentoStatus.EM_ANALISE ||
                        this.pagamento.status ===
                            pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO)) ||
                (this.$route.name == 'DespesasGerais_Financeiro_Pagamentos_Detalhar' &&
                    this.$temAcesso('DESP-GERAIS-FINAN-PAG-02') &&
                    this.pagamento.status ===
                        pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO)
            )
        },

        mostrarBtnAprovar() {
            return (
                (this.$temAcesso('DESP-GERAIS-FINAL-PAG-02') &&
                    (this.pagamento.status === pagamentoStatus.EM_ANALISE ||
                        this.pagamento.status === pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO) &&
                    this.despesasComprometidas &&
                    this.pagamento.despesaPermiteAcao &&
                    !this.pagamento.requerAnexoParaBoleto &&
                    this.pagamento.anexos.length > 0) ||
                (!this.$temAcesso('DESP-GERAIS-FINAN-PAG-02') &&
                    this.pagamento.status ===
                        pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO)
            )
        },

        despesasComprometidas() {
            return this.pagamento.despesas.every(p => {
                return p.statusComprometimentoId === 1
            })
        },

        perfil() {
            if (
                this.pagamento.status === pagamentoStatus.EM_ANALISE ||
                this.pagamento.status ===
                    pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO
            ) {
                return perfil.FINALIZACAO
            } else if (
                this.pagamento.status ===
                pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO
            ) {
                return perfil.FINANCEIRO
            }
            return perfil.GERAL
        },

        insereDetalheReprovacao() {
            if (this.categoriaReprovacaoId == null) {
                return false
            }

            if (this.categoriasDetalheId.length == 0) {
                return false
            }
            
            if (!this.categoriasDetalheId.includes(this.categoriaReprovacaoId)) {
                return false
            }

            return true
        },

        insereEmailGestorFMO() {
            if (this.categoriaReprovacaoId == null) {
                return false
            }

            if (this.categoriaFMOId == null) {
                return false
            }
            
            if (!(this.categoriaFMOId == this.categoriaReprovacaoId)) {
                return false
            }

            return true
        }
    },

    validations: {
        detalheReprovacao: {
            obrigatorio() {
                if (this.insereDetalheReprovacao && (this.detalheReprovacao == null || this.detalheReprovacao == '')) {
                    return false
                }
                return true
            }
        },
        emailGestorFMO: {
            obrigatorio() {
                if (this.insereEmailGestorFMO && (this.emailGestorFMO == null || this.emailGestorFMO == '')) {
                    return false
                }
                return true
            }
        },
        categoriaReprovacaoId: {
            required
        }
    },

    watch: {
        mostrarModalDetalheReprovacao() {
            if (this.mostrarModalDetalheReprovacao) {
                this.obterCategoriasReprovacao()
            } 
        }
    }
}
</script>
